import type { MouseEventHandler, ReactNode } from 'react';

export type afterSocialLoginSuccess = {
  type: SocialLoginPlatformEnum;
  socialId: string;
  email: string;
  ageRange?: string;
  birthday?: string;
  birthdayType?: 'LUNAR' | 'SOLAR';
  birthYear?: string;
  gender?: 'male' | 'female';
  name?: 'string';
  phoneNumber?: string;
}

export type SocialLoginVariant = 'legacy' | 'draft';

export type SocialLoginButtonsProps = {
  afterSocialLoginSuccess: (params: afterSocialLoginSuccess) => void,
  dataSocial: SocialLoginPlatformEnum,
  dbinsurance?: boolean;
  variant?: SocialLoginVariant;
  recentLogin?: SocialLoginPlatformEnum;
}

export type SocialLoginBtnProps = {
  onClick: (() => void) | MouseEventHandler<HTMLButtonElement>,
  backgroundColor?: string,
  fontColor?: string,
  additionalStyle?: string,
  icon: ReactNode,
  text: string,
  variant?: SocialLoginVariant;
}

export enum SocialLoginPlatformEnum {
  NAVER = 'naver',
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  KAKAO = 'kakao',
  APPLE = 'apple'
}